import { Libraries } from '@react-google-maps/api/src/utils/make-load-script-url';
import { ICoord } from '../models/coord.model';

export const GOOGLE_MAPS_APIKEY = 'AIzaSyASxYW-Qtr1Tss_QOLU-oFknMmBP1LgVS4';
export const GOOGLE_MAPS_DEFAULT_ZOOM = 7;
export const GOOGLE_MAPS_DEFAULT_ZOOM_FOCUSED = 14;

export const GOOGLE_MAPS_SEARCH_MINIMUM_ZOOM_TO_SEARCH = 17;

export const GOOGLE_MAPS_DEFAULT_LIBRARIES: Libraries = ['places'];
export const GOOGLE_MAPS_DRAWING_LIBRARIES: Libraries = ['drawing', 'places'];
export const GOOGLE_MAPS_TILE_SIZE = 256;
export const GOOGLE_MAPS_ID = "google-map";

export const GOOGLE_MAPS_SCRIPT_ID = "google-map-script";

export const GOOGLE_MAPS_OPTIONS_SEARCH = {
  streetViewControl: false,
  fullscreenControl: true,
  mapTypeControl: false
};

export const markerIcon = (opts: { fillColor: string; strokeColor: string; }) => Object.assign({
  path: google.maps.SymbolPath.CIRCLE,
  fillColor: '#ffffff',
  fillOpacity: 1,
  strokeColor: '#000',
  strokeWeight: 2,
  scale: 8
}, opts);

export function fromLatLngToPoint(latLng: google.maps.LatLng, map: google.maps.Map) {
  var topRight = map.getProjection()!.fromLatLngToPoint(map.getBounds()!.getNorthEast());
  var bottomLeft = map.getProjection()!.fromLatLngToPoint(map.getBounds()!.getSouthWest());
  var scale = Math.pow(2, map.getZoom()!);
  var worldPoint = map.getProjection()!.fromLatLngToPoint(latLng);
  return new google.maps.Point(Math.floor((worldPoint!.x - bottomLeft!.x) * scale), Math.floor((worldPoint!.y - topRight!.y) * scale));
}

export const getOverlayPixelPositionOffset = (width: number, height: number, coords: ICoord | undefined, map: google.maps.Map) => {
  const div = document.getElementById(GOOGLE_MAPS_ID);
  const mapWidthPx = div === null ? 0 : div.clientWidth;
  let overlayBottomLeftOffsetX = -(width / 2);
  let overlayBottomLeftOffsetY = -(height + 10);
  const latLng: google.maps.LatLng = new google.maps.LatLng(coords!.lat, coords!.lng);
  const point = fromLatLngToPoint(latLng, map);

  if ((point.x + overlayBottomLeftOffsetX + width) > mapWidthPx) {
    overlayBottomLeftOffsetX -= width / 2 + 10;
  }

  if ((point.x + overlayBottomLeftOffsetX) < 0) {
    overlayBottomLeftOffsetX = 10;
  }

  if ((point.y + overlayBottomLeftOffsetY) < 0) {
    overlayBottomLeftOffsetY += height + 20;
  }

  return {
    x: overlayBottomLeftOffsetX,
    y: overlayBottomLeftOffsetY
  }
};

export const GOOGLE_MAPS_DEFAULT_MAP_CENTER_COORD: ICoord = { lat: 43.653225, lng: -79.383186 };

export const SEARCH_RESULTS_PAGE_PATH_STR = 'p_';